// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1QBjG","placeholdersHeader":"styles_placeholdersHeader__1bVOB","editorStyle":"styles_editorStyle__2k_t6","placeholdersBox":"styles_placeholdersBox__3Nseh"};